<template>
  <v-card class="print-window px-5 pt-5 pb-5">
    <v-btn
      v-show="showPrint"
      color="primary"
      small
      class="mb-3"
      @click="printOrder"
    >
      <v-icon>
        mdi-printer
      </v-icon>
      Print
    </v-btn>
    <div
      v-show="$vuetify.breakpoint.mdAndUp"
      id="printSection"
      ref="printSection"
      style="width:800px;"
      class="mx-auto"
    >
      <center style="margin-bottom: 10px;">
        <h3>教練聯盟</h3>
        <h3>Asian Alliance Limited</h3>
      </center>
      <v-row>
        <v-col>
          <v-row
            v-for="config in studentReviewConfig"
            :key="config.prop"
          >
            <v-col class="font-weight-bold">
              {{ config.label }}
            </v-col>
            <v-col>
              {{ config.formatter?config.formatter(studentData[config.prop]):studentData[config.prop] }}
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row
            v-for="config in orderReviewConfig"
            :key="config.prop"
          >
            <v-col class="font-weight-bold">
              {{ config.label }}
            </v-col>
            <v-col>
              {{ config.formatter?config.formatter(orderInfo[config.prop]):orderInfo[config.prop] }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div>
        <h5>Terms & Conditions</h5>
        <div
          class="terms-condition"
          v-html="termsCondition"
        ></div>
      </div>
      <v-row id="VueSignaturePad">
        <v-col
          md="6"
          lg="6"
          ex-lg="6"
          cols="12"
        >
          <section>
            <v-img
              :height="200"
              width="50%"
              contain
              aspect-ratio="16/9"
              :src="signatureImageSrc"
            ></v-img>
          </section>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row>
            <v-col>{{ studentData.fullName }}</v-col>
          </v-row>
          <v-row>
            <v-col>{{ moment().format('yyyy-MM-DD') }}</v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col><span class="font-weight-bold">Prepared by</span></v-col>
          </v-row>
          <v-row>
            <v-col><span class="font-weight-bold">{{ orderInfo.salesmanName }}</span></v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script setup>
import { ref, onMounted, computed, toRefs, watch } from 'vue'
import { useRouter } from 'vue-router/composables'
import { getVuetify } from '@core/utils'
import moment from '@/utils/moment'
import { useStore } from '@/store'
import { formatDate, loading, fileToBase64 } from '@/utils/helper'
import { getItem as getTerms } from '@/api/termsCondition'
import { getToken, getUserData, removeUserData, setUserData } from '@/utils/auth'
import { getItem, downloadSignature } from '@/api/salesOrder'

const printSection = ref(null)

const $vuetify = getVuetify()
function printOrder() {
  // Get HTML to print from element
  let prtHtml = `<section class='print-window px-5 pt-5 pb-5'>${printSection.value.innerHTML}</section>`
  console.log('prtHtml', prtHtml)
  if (prtHtml.indexOf('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>') > 0) {
    console.log('has button')
    prtHtml = prtHtml.replace('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>', '')
  }
  console.log('replaced prtHtml', prtHtml)

  // Get all stylesheets HTML
  let stylesHtml = ''
  for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    stylesHtml += node.outerHTML
  }

  // Open the print window
  const printCnt = `<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(printCnt)
  } else {
    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
    console.log('printCnt', printCnt)
    WinPrint.document.write(printCnt)
    setTimeout(() => {
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }, 500)
  }
}

defineExpose({
  printOrder,
})

const signatureImageSrc = ref('https://cdn.vuetifyjs.com/images/parallax/material.jpg')
const termsCondition = ref('Terms and Conditions is not available. Please contact website administrator.')

const studentData = ref({
  id: -1,
  userNo: 'BAM2200001',
  fullName: 'Paul Chan',
  gender: 'M',
  hkid: 'A123456(7)',
  mobileNo: '91234321',
  email: 'lrzjason@gmail.com',
})
const orderInfo = ref({
  id: -1,
  orderSalesmens: [
    {
      userRecord: {
        fullName: 'Jason Chan',
      },
    },
  ],
})

const store = useStore()

const orderReviewConfig = ref([
  {
    label: 'Order No',
    prop: 'orderNo',
  },
  {
    label: 'Course',
    prop: 'courseID',
    formatter(value) {
      const target = store.getters.course.filter(record => record.id === value)
      if (target.length > 0) {
        return target[0].courseName
      }

      return value
    },
  },
  {
    label: 'Program',
    prop: 'sessionTotal',
  },
  {
    label: 'Total Amount',
    prop: 'totalAmount',
  },
  {
    label: 'Effective Date',
    prop: 'effectiveDate',
    formatter(value) {
      if (value) {
        return formatDate(value)
      }

      return formatDate(new Date())
    },
  },
  {
    label: 'Expiry Date',
    prop: 'expiryDate',
    formatter(value) {
      if (value) {
        return formatDate(value)
      }

      return formatDate(new Date())
    },
  },
  {
    label: 'Promotion',
    prop: 'promotionID',
    formatter(value) {
      const target = store.getters.promotionItems.filter(record => record.id === value)
      if (target.length > 0) {
        return target[0].fullName
      }

      return ''
    },
  },
])
const token = ref('')
const internalOrderID = ref('')
const router = useRouter()
const props = defineProps({
  orderId: {
    type: Number,
    default: -1,
  },
  showPrint: {
    type: Boolean,
    default: false,
  },
})
const { orderId } = toRefs(props)
onMounted(() => {
  console.log('router', router)
  if (router.currentRoute.params.orderId) {
    internalOrderID.value = router.currentRoute.params.orderId
  }
  if (router.currentRoute.params.token) {
    token.value = router.currentRoute.params.token
    setUserData({
      userToken: { token: token.value },
    })
  }

  // console.log('orderId.value', orderId.value)
  // console.log('token.value', token.value)

  store.dispatch('course/list', {})
    .then(result => {
      console.log('course result', result)
    })
    .catch(err => {
      console.log('err', err)
    })

  if (orderId.value > 0) {
    internalOrderID.value = orderId.value
  }
  loading(false)

  // signatureImageSrc.value = `${process.env.VUE_APP_BASE_API}SalesOrder/Signature/${internalOrderID.value}`
  downloadSignature(internalOrderID.value).then(res => {
    console.log('downloadSignature', res)

    // signatureImageSrc.value = res

    fileToBase64(res).then(result => {
      console.log('result', result)
      signatureImageSrc.value = result
    })

    // signatureImageSrc.value = res.data.record
  })
  console.log('signatureImageSrc.value', signatureImageSrc.value)
  getItem(internalOrderID.value).then(res => {
    console.log('order res', res)
    orderInfo.value = res.data.record
    studentData.value = orderInfo.value.userRecord

    getTerms(orderInfo.value.termsID).then(response => {
      console.log('termsCondition', response.data.record)
      if (response.data.record) {
        termsCondition.value = response.data.record.content
      }
    })
  })
    .catch(err => {
      console.log('err', err)
    })
    .finally(() => {
      loading(false)
    })
})
watch(orderId, value => {
  console.log('orderID', value)
  if (value) {
    internalOrderID.value = value
  }
  getItem(internalOrderID.value).then(res => {
    console.log('order res', res)
    orderInfo.value = res.data.record
    studentData.value = orderInfo.value.userRecord
  })
    .catch(err => {
      console.log('err', err)
    })
    .finally(() => {
      loading(false)
    })
})

// const salemanName = computed(() => {
//   if (orderInfo.value != null && orderInfo.value.salesmanName) {
//     return orderInfo.value.salesmanName
//   }

//   return '[Salesman]'
// })

const studentReviewConfig = ref([
  {
    label: 'Membership No',
    prop: 'userNo',
  },
  {
    label: 'Membership Name',
    prop: 'fullName',
  },
  {
    label: 'Gender',
    prop: 'gender',
    formatter(value) {
      if (value === 'M') {
        return 'Male'
      }

      return 'Female'
    },
  },
  {
    label: 'HK ID',
    prop: 'hkid',
  },
  {
    label: 'Telephone',
    prop: 'mobileNo',
  },
  {
    label: 'Email',
    prop: 'email',
  },
])
</script>
<style >
.terms-condition p{
  margin-bottom: 3px !important;
}
@media print {
    /* styles here */
  .not-print{
    display: none;
  }
  body {
    /* display: block !important; */
    -webkit-print-color-adjust:exact;
    print-color-adjust:exact;
  }
}
.print-window .not-print{
  display: none;
}
</style>
